import {getUrlVar,getUrlVars,scrollToElement,loadLibrary} from './Util.js';
import {LIB_URL} from '../App';

/**
 *  Страница проматывается до видео с id = video2, проматывается на 450 секунд (start:450), раскрывается на все окно браузера (аullscreen)
 *  URL?videocontrol=video1,siart:300+video2,start:450,active,fullscreen
*/

const VideoUrlControl = () => {
    const videos = document.querySelectorAll('.text video, .video-block');

    if (!videos.length) return;

    // обработка ссылок на видео расположенных на этой же странице (клик проматывает к видео)
    Array.from(document.querySelectorAll('a[href*="videocontrol="]')).forEach((link) => {
        const videoControl = getUrlVars(link.href)['videocontrol'];
        const control = parseControl(videoControl);
        const id = Object.keys(control)[0];
        const video = document.querySelector(`video#${id}`);

        $(link).on('click', (e) => {
            e.preventDefault();
            if (video) {
                // видео проматывается до нужного места в милисекундах
                if (control[id].start) {
                    video.currentTime = Number(control[id].start);
                }

                // прокручиваем старницу до видео
                scrollToElement($(video));
            }

            loadLibrary(LIB_URL.PLYR, () => {
                const plyrParentDom = document.querySelector(`#${id}.js-plyr-parent`);
                const player = plyrParentDom && plyrParentDom.getPlyr && plyrParentDom.getPlyr();

                if (player) {
                    if (control[id].start) {
                        player.currentTime = Number(control[id].start);
                    }

                    // видео проигрывается автоматически
                    if (control[id].play) {
                        player.play();
                    }
                }
            });
        });
    });

    // страница открыта с гет параметром videocontrol
    const videoControl = getUrlVar('videocontrol');

    if (!videoControl) return;

    const control = parseControl(videoControl);

    for (let id in control) {
        const video = document.querySelector(`video#${id}`);

        if (video) {
            // видео проматывается до нужного места в милисекундах
            if (control[id].start) {
                video.currentTime = control[id].start;
            }

            // прокручиваем старницу до видео
            if (control[id].active) {
                scrollToElement($(video));
            }

            // раскрываем видео на все окно браузера
            if (control[id].fullscreen) {
                loadLibrary(LIB_URL.PLYR, () => {
                    video.plyr.on('ready', event => {
                        const instance = event.detail.plyr;

                        scrollToElement($(video));
                        instance.elements.container.classList.add('_fullscreen');
                        instance.elements.container.querySelector('[data-plyr="fullscreen"]').classList.add('plyr__control--pressed');

                        App.H.one('keyup', function (e) {
                            // закрытие видео по нажатию Esc
                            if (e.keyCode === 27) {
                                fullscreenOne(instance);
                            }
                        });
                    });
                    video.plyr.on('enterfullscreen', fullscreenOne);
                });
            }
        }
    }
};

function fullscreenOne(event) {
    const instance = event.detail ? event.detail.plyr : event;

    instance.elements.container.classList.remove('_fullscreen');
    instance.fullscreen.exit();
    instance.off('enterfullscreen', fullscreenOne);
}

function parseControl(string) {
    string = decodeURIComponent(string);

    if (!string.match(/^(\+?[^:+,]+(,[^:+,]+(:[^:+,]+)?)+)+$/g)) return [];

    try {
        let result = string.split('+');

        return result.length && result.reduce((controls, item) => {
            const params = item.split(',');
            const id = params.shift();

            controls[id] = params.reduce((obj, item) => {
                const arr = item.split(':');

                obj[arr[0]] = arr[1] ? arr[1] : true;
                return obj;
            }, {});

            return controls;
        },{});
    } catch(err) {
        return [];
    }
}

export default VideoUrlControl;

new VideoUrlControl();
